import { enableNetwork } from 'firebase/firestore';
import { withTimeout } from '../network/timeout.js';

export function isFirestoreOfflineError(err) {
  const code = err?.code || '';
  const msg = String(err?.message || '').toLowerCase();
  return (
    code === 'unavailable' ||
    msg.includes('offline') ||
    msg.includes('failed to get document because the client is offline')
  );
}

/** @param {{ getFirebase: () => object }} options */
export function createWithFirestoreRetry({ getFirebase }) {
  return async function withFirestoreRetry(fn, attempts = 2) {
    let lastErr;
    for (let i = 0; i < attempts; i++) {
      try {
        return await withTimeout(fn(), 15000, 'La base de datos no respondió a tiempo.');
      } catch (e) {
        lastErr = e;
        const retry =
          (isFirestoreOfflineError(e) || e?.code === 'deadline-exceeded') && i < attempts - 1;
        if (!retry) break;
        await enableNetwork(getFirebase().db).catch(() => {});
        await new Promise((r) => setTimeout(r, 800));
      }
    }
    throw lastErr;
  };
}
